// extracted by mini-css-extract-plugin
export var deleteIcon = "_s1-5";
export var deleteOption = "_s1-3";
export var divider = "_s1-2";
export var downloadIcon = "_s1-4";
export var drawer = "_s1-0";
export var drawerFooter = "_s1-6";
export var drawerOpen = "_s1-1";
export var highlighted = "_s1-7";
export var lighterHighlight = "_s1-8";